<script>
export let label = ""
</script>

<button type="submit" class="btn btn-solid ml-auto">{label}</button>
